import { createRoot } from "react-dom/client";
import { store, persistor } from "./globals";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { withSuspense } from "components";
import { lazy } from "helpers";
import ErrorBoundary from "./components/misc/ErrorBoundary";
import { initAppInsights } from "./observability/appInsights";

//Ensure bootstrap css is loaded before application styling so that it can be overriden in most cases
import "normalize.css";
import "./bootstrap.min.css";
import "animate.css";
import "./index.scss";

const MaxLoader = <div className="suspense-loader max">Loading...</div>;

const App = withSuspense(
	lazy(() => import("./App")),
	MaxLoader
);

initAppInsights();

// React 19 createRoot API
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<ErrorBoundary boundaryName="RootApp">
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</ErrorBoundary>
);

import("./serviceWorker").then(serviceWorker => serviceWorker.unregister());